import _AutoComplete from "@arco-design/web-react/es/AutoComplete";
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React, { useMemo } from 'react';
import { IconSearch } from '@arco-design/web-react/icon';
import style from './style.less';
import useLocale from '@src/hooks/useLocale';
export default function MenuSearch(props) {
  var t = useLocale().t;
  var data = useMemo(function () {
    var _a, _b;
    var routers = props.routers || {};
    var items = [];
    var _loop_1 = function _loop_1(key) {
      if ((_a = routers[key]) === null || _a === void 0 ? void 0 : _a.items) {
        (_b = routers[key]) === null || _b === void 0 ? void 0 : _b.items.forEach(function (item) {
          if (item.items) {
            item.items.forEach(function (x) {
              items.push(__assign(__assign({}, x), {
                parentKey: key
              }));
            });
          } else {
            items.push(__assign(__assign({}, item), {
              parentKey: key
            }));
          }
        });
      }
    };
    for (var key in routers) {
      _loop_1(key);
    }
    return items;
  }, [props.routers]);
  return /*#__PURE__*/React.createElement("div", {
    className: style['search-wrapper']
  }, /*#__PURE__*/React.createElement(_AutoComplete, {
    onChange: function onChange(value) {
      var item = data.find(function (x) {
        return x.name === value;
      });
      if (item) {
        props.onSelect(item.parentKey + '/' + item.key);
      }
    },
    data: data.map(function (x) {
      return x.name;
    }),
    className: style['search'],
    inputProps: {
      prefix: /*#__PURE__*/React.createElement(IconSearch, {
        style: {
          marginLeft: -12
        }
      }),
      placeholder: t['design.menu.input.placeholder']
    }
  }));
}